<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>

      <div class="content">
        <h2 class="center-align">Pricing</h2>
        <div class="margin-top-25 center-align">
          <h5>7 days free trial. Afterwards, each app is billed per minute. You only pay when your app is running.</h5>
        </div>

        <!-- Pricing cards -->
        <div class="margin-top-50">
          <b-row
            class="justify-content-center"
            style="max-width: 1100px; margin-left: auto; margin-right: auto;"
          >
            <b-col
              cols="12"
              md="6"
              lg="4"
              xl="3"
              class="d-flex justify-content-center mb-4"
              v-for="(plan, key) in plans"
              :key="key"
            >
              <b-card
                :title="'Size ' + key.toUpperCase()"
                class="text-center"
                border-variant="primary"
                header-bg-variant="primary"
                header-text-variant="white"
                style="width: 230px;"
              >
                <p class="mb-2"><strong>{{ plan.ram }} RAM</strong></p>
                <p class="mb-2 text-primary font-weight-bold">{{ plan.month }}€ / month</p>
                <p class="text-muted">(~ {{ plan.minute | round6Decimals }}€ / minute)</p>
              </b-card>
            </b-col>
          </b-row>
          <p class="text-center">CPU & Disks are shared</p>
          <div class=" my-5"></div>

          <!-- Price estimation -->
          <div class="center-form">
            <h4 class="center-align">Price estimation</h4>
            <b-form-group id="size" description="Need bigger instances? Contact us on the chat">
              <b>Choose size</b>
              <br>
              <b-form-radio 
                class="inline margin-2"
                v-model="size"
                name="radio"
                value="xs"
              >
                XS
              </b-form-radio>
              <b-form-radio 
                class="inline margin-2"
                v-model="size"
                name="radio"
                value="s"
              >
                S
              </b-form-radio>
              <b-form-radio 
                class="inline margin-2"
                v-model="size"
                name="radio"
                value="m"
              >
                M
              </b-form-radio>
              <b-form-radio 
                class="inline margin-2"
                v-model="size"
                name="radio"
                value="l"
              >
                L
              </b-form-radio>
              <b-form-radio 
                class="inline margin-2"
                v-model="size"
                name="radio"
                value="xl"
              >
                XL
              </b-form-radio>
              <b-form-radio 
                class="inline margin-2"
                v-model="size"
                name="radio"
                value="xxl"
              >
                XXL
              </b-form-radio>
              <b-form-radio 
                class="inline margin-2"
                v-model="size"
                name="radio"
                value="xxxl"
              >
                XXXL
              </b-form-radio>
              <br>
            </b-form-group>
            <div class="margin-top-25">
              <b>Choose countries</b>
              <b-form-input 
                v-model="country"
                type="range"
                min="1"
                max="10"
              ></b-form-input>
              <span>Your app is deployed in {{ country }} country(ies)</span>
            </div>
            <div class="margin-top-25">
              <b>Choose scale</b>
              <b-form-input 
                v-model="scale"
                type="range"
                min="1"
                max="10"
              ></b-form-input>
              <span>Your app is replicated {{ scale }} time(s)</span>
            </div>
            <div class="margin-top-25 center-align">
              <h5 class="inline">If your app runs 24/7 over a month of 30 days, you will pay <b>{{ price.month }}€</b></h5> <span>(~ {{ price.minute | round6Decimals }}€ / minute)</span>
            </div>
          </div>
        </div>

      <section class="center-align margin-100">
        <h2 class="text-3xl font-semibold margin-bottom">🚀 Ready to Try?</h2>
        <p>7 days free trial. No engagement. Get your app running today.</p>
        <router-link :to="{ name: user.email ? 'Deployments' : 'SignUp' }">
          <button class="cta">Start Now</button>
        </router-link>
      </section>

      </div>
    </b-col>
  </b-row>
</template>

<script>

  export default {
    name: 'Pricing',
    components: {  },
    props: {

    },
    data() {
      return {
        size: 'xs',
        country: 1,
        scale: 1,
        sizePrice: {
          xs: {
            month: 1,
            minute: 0.000023148148
          },
          s: {
            month: 2,
            minute: 0.000046296296
          },
          m: {
            month: 4,
            minute: 0.000092592592
          }, 
          l: {
            month: 8,
            minute: 0.000185185184
          },
          xl: {
            month: 16,
            minute: 0.000370370368
          },
          xxl: {
            month: 32,
            minute: 0.000740740736
          },
          xxxl: {
            month: 64,
            minute: 0.001481481472
          }
        },
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      price() {
        return {
          month: this.sizePrice[this.size].month * this.scale * this.country,
          minute: this.sizePrice[this.size].minute * this.scale * this.country
        }
      },
      plans() {
      return {
          xs: { ram: '128MB', month: this.sizePrice.xs.month, minute: this.sizePrice.xs.minute },
          s: { ram: '256MB', month: this.sizePrice.s.month, minute: this.sizePrice.s.minute },
          m: { ram: '512MB', month: this.sizePrice.m.month, minute: this.sizePrice.m.minute },
          l: { ram: '1024MB', month: this.sizePrice.l.month, minute: this.sizePrice.l.minute },
          xl: { ram: '2048MB', month: this.sizePrice.xl.month, minute: this.sizePrice.xl.minute },
          xxl: { ram: '4096MB', month: this.sizePrice.xxl.month, minute: this.sizePrice.xxl.minute },
          xxxl: { ram: '8192MB', month: this.sizePrice.xxxl.month, minute: this.sizePrice.xxxl.minute },
        }
      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
